import { useState } from 'react'
import { Input } from './Input'
import { Modal } from './Modal'
import { Text } from './Text'

interface DialogProps {
	isOpen: boolean
	onClose: () => void
	onConfirm?: () => void
	title: string
	message: string
	type: 'delete' | 'archive' | 'confirm'
	confirmLabel?: string
	requireConfirmText?: boolean
	confirmText?: string
	isConfirmLoading?: boolean
}

export const Dialog = ({
	isOpen,
	onClose,
	onConfirm,
	title,
	message,
	type,
	confirmLabel,
	requireConfirmText = false,
	confirmText = type.toUpperCase(),
	isConfirmLoading = false,
}: DialogProps) => {
	const [inputText, setInputText] = useState('')

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setInputText(e.target.value)
	}

	const handleClose = () => {
		setInputText('')
		onClose()
	}

	const canConfirm = !requireConfirmText || inputText === confirmText

	const buttonVariant = type === 'delete' || type === 'archive' ? 'destructive' : 'primary'

	return (
		<Modal
			isOpen={isOpen}
			onClose={handleClose}
			title={title}
			buttons={
				onConfirm && confirmLabel
					? [
							{
								children: 'Cancel',
								onClick: handleClose,
								variant: 'secondary',
							},
							{
								children: confirmLabel,
								onClick: () => {
									if (canConfirm) {
										onConfirm()
										handleClose()
									}
								},
								variant: buttonVariant,
								disabled: !canConfirm,
								isLoading: isConfirmLoading,
							},
						]
					: undefined
			}>
			<Text variant='small' weight='regular' className='mb-4'>
				{message}
				{requireConfirmText && (
					<>
						<br />
						<br />
						If you want to continue please type the word {confirmText} to confirm.
					</>
				)}
			</Text>
			{requireConfirmText && (
				<div className='mt-6'>
					<Input placeholder={`Type ${confirmText} to confirm`} value={inputText} onChange={handleInputChange} />
				</div>
			)}
		</Modal>
	)
}
